<template>
    <van-dialog
        :value="show"
        :title="$t('请选择支付方式')"
        :confirm-button-text="$t('确认')"
        :cancel-button-text="$t('取消')"
        confirm-button-color="#cc9733"
        show-cancel-button
        @confirm="handleConfirm"
        @cancel="handleCancel"
        @close="handleCancel"
    >
        <van-radio-group v-model="selectedPayType" direction="vertical" class="pay-type-radio-group">
            <van-radio name="apple">Apple Pay</van-radio>
            <van-radio name="credit">Credit Card</van-radio>
        </van-radio-group>
    </van-dialog>
</template>

<script>
import { Dialog, Radio, RadioGroup } from 'vant'

export default {
    name: 'PayTypeDialog',
    components: {
        VanDialog: Dialog.Component,
        VanRadio: Radio,
        VanRadioGroup: RadioGroup,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            selectedPayType: 'apple',
        }
    },
    watch: {
        show(val) {
            if (val) {
                this.selectedPayType = 'apple'
            }
        },
    },
    methods: {
        handleCancel() {
            this.$emit('cancel')
        },
        handleConfirm() {
            this.$emit('confirm', {
                type: this.selectedPayType,
                data: this.data,
            })
        },
    },
}
</script>

<style scoped lang="scss">
.pay-type-radio-group {
    margin: 30px 20px;

    .van-radio {
        justify-content: center;
    }

    .van-radio + .van-radio {
        margin-top: 12px;
    }
}
</style>
